import {
  EXPORT_SFES_API,
  GET_SFE_KEY_COLUMNS_API,
  SEARCH_SFES_API
} from '~/constants/APIs'
import { ISEFKeyColumn, ISFESearchRequest, ISFESearchResponse } from '~/models'
import axiosClient from './axiosClient'

export const sfeApis = {
  searchSFEs: (params: ISFESearchRequest | null) =>
    axiosClient.get(SEARCH_SFES_API, { params }) as unknown as ISFESearchResponse,
  getSFEKeyColumns: () =>
    axiosClient.get(GET_SFE_KEY_COLUMNS_API) as unknown as ISEFKeyColumn[],
  exportSFEs: (params: ISFESearchRequest | null) =>
    axiosClient.get(EXPORT_SFES_API, { params, responseType: 'blob' })
}
